import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

const TOKEN_KEY = "hbt_token";
const REFRESH_KEY = "hbt_refresh";
const USER_KEY = "hbt_user";

export const setAuth = (token, refreshToken, user) => {
  if (token) localStorage.setItem(TOKEN_KEY, token);
  if (refreshToken) localStorage.setItem(REFRESH_KEY, refreshToken);
  if (user) localStorage.setItem(USER_KEY, JSON.stringify(user));
};

export const clearAuth = () => {
  localStorage.removeItem(TOKEN_KEY);
  localStorage.removeItem(REFRESH_KEY);
  localStorage.removeItem(USER_KEY);
};

export const getStoredUser = () => {
  try {
    const raw = localStorage.getItem(USER_KEY);
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
};

api.interceptors.request.use((config) => {
  const token = localStorage.getItem(TOKEN_KEY);
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

// Attempt single refresh on 401; queue concurrent requests behind the same refresh call
let refreshPromise = null;
const doRefresh = async () => {
  const refresh_token = localStorage.getItem(REFRESH_KEY);
  if (!refresh_token) return null;
  try {
    const res = await axios.post(`${API}/auth/refresh`, { refresh_token });
    localStorage.setItem(TOKEN_KEY, res.data.token);
    localStorage.setItem(REFRESH_KEY, res.data.refresh_token);
    return res.data.token;
  } catch {
    clearAuth();
    return null;
  }
};

api.interceptors.response.use(
  (r) => r,
  async (err) => {
    const status = err?.response?.status;
    const original = err.config;
    // Do not try to refresh for the refresh endpoint itself, or if already retried
    if (status === 401 && original && !original._retried && !original.url?.includes("/auth/")) {
      original._retried = true;
      refreshPromise = refreshPromise || doRefresh();
      const newToken = await refreshPromise;
      refreshPromise = null;
      if (newToken) {
        original.headers.Authorization = `Bearer ${newToken}`;
        return api(original);
      }
    }
    if (status === 401) {
      clearAuth();
    }
    return Promise.reject(err);
  }
);
